import { useEffect, useState } from 'react';

export function useNow() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    let timer = 0;
    function tick() {
      window.clearTimeout(timer);

      const now = new Date();
      const next = 1000 - (now.valueOf() % 1000);

      setNow(now);
      timer = window.setTimeout(tick, next);
    }

    tick();

    return () => window.clearTimeout(timer);
  }, []);

  return now;
}
